import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { useLang } from "../i18n/LanguageContext";

export default function Privacy() {
  const { t } = useLang();
  const P = t.privacy;

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, []);

  return (
    <div data-testid="privacy-page" className="min-h-screen bg-[#F9FAFB]">
      <Navbar />
      <main className="pt-32 md:pt-40 pb-24 md:pb-32">
        <div className="container-vel max-w-3xl">
          <Link
            to="/"
            data-testid="privacy-back-link"
            className="inline-flex items-center gap-2 font-body text-xs tracking-[0.22em] uppercase text-ink-soft hover:text-coral transition-colors duration-300"
          >
            <ArrowLeft size={14} strokeWidth={1.75} />
            {P.back}
          </Link>

          <div className="overline mt-10 mb-5" data-testid="privacy-overline">
            {P.overline}
          </div>
          <h1
            data-testid="privacy-heading"
            className="font-heading text-4xl sm:text-5xl lg:text-6xl text-navy font-light leading-[1.05] tracking-tight"
          >
            {P.headlinePre}
            <br />
            <em className="not-italic underline decoration-coral decoration-2 underline-offset-8">
              {P.headlineHighlight}
            </em>
            .
          </h1>

          <div
            data-testid="privacy-body"
            className="mt-12 space-y-6 font-body text-base sm:text-lg text-ink-muted leading-relaxed font-light"
          >
            <p>{P.p1}</p>
            <p>{P.p2}</p>
            <ol className="list-decimal pl-6 space-y-3 marker:text-coral marker:font-medium">
              {P.list.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ol>
            <p>{P.p3}</p>
            <p>{P.p4}</p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
